export default __webpack_public_path__ + "assets/objectTypeClicked/atputas_vieta_peleks.png";